<template>
  <div class="inside-modal">
    <!-- ============= Logo / title =============  -->
    <div class="row f-row text-center">
      <div class="col col-12 mt-5">
        <img
          :src="logo"
          @mouseover="logo = logo_blue"
          @mouseout="logo = logo_white"
          height="30"
          alt=""
          style="padding: 0"
        />
      </div>
    </div>
    <div
      class="row f-row text-center"
      style="border-bottom: 1px solid var(--graylightbackground) !important;"
    >
      <div class="col col-12 mt-1 mb-3">
        {{ createEditTextExpo }}
      </div>
    </div>
    <!-- ============= form =============  -->
    <div class="row f-row mt-3">
      <div class="col col-1"></div>
      <div class="col col-10">
        <form @submit.prevent="validateBeforeSubmit">
          <!-- https://logaretm.github.io/vee-validate/guide/basics.html#validation-provider -->
          <!-- ============= required fields =============  -->
          Required fields:<br />
          <table
            class="table table-sm table-responsive table-borderless table-data-controls my-data-table"
            style="width: 100%;"
          >
            <tbody>
              <tr>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('portfolio')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Portfolio
                  </label>
                  <input
                    v-validate="'required|max:150'"
                    class="custom-input-2"
                    style="height: 19px!important;"
                    name="portfolio"
                    placeholder="Portfolio Name"
                    v-model="newEditedItemExpo.fk_idportafolio"
                    :class="{
                      input: true,
                      'is-danger': errors.has('portfolio'),
                    }"
                    type="text"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">Rate</label>
                  <select
                    class="dropdown-form dropdown-sm"
                    v-model="newEditedItemExpo.fk_idcurrency"
                    @change="onCrudExpoCurrency"
                  >
                    <option
                      v-for="currency in allCurrencies"
                      v-bind:value="currency.currency_name"
                      :key="currency.id"
                      >{{ currency.currency_name.toUpperCase() }}</option
                    >
                  </select>
                </td>
                <td class="my-data-td">
                  <label class="txt-label">Exposure Type</label>
                  <select
                    class="dropdown-form dropdown-sm"
                    v-model="newEditedItemExpo.fk_idexposureoption"
                  >
                    <option
                      v-for="type in expoOptions"
                      v-bind:value="type.name"
                      :key="type.id"
                      >{{ type.name.toUpperCase() }}</option
                    >
                  </select>
                </td>
                <td class="my-data-td">
                  <label class="txt-label">Notional</label>
                  <InputNumber
                    style="height: 19px!important;"
                    :tableFormat="false"
                    :value="+newEditedItemExpo.notional"
                    @input="(val) => onUserNotionalChange(val)"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">Notional Currency</label>
                  <select
                    class="dropdown-form dropdown-sm"
                    v-model="newEditedItemExpo.fk_idcountry_currency"
                  >
                    <option
                      v-for="currency in leftRightCurrExpo"
                      v-bind:value="currency"
                      :key="currency.id"
                      >{{ currency.toUpperCase() }}</option
                    >
                  </select>
                </td>
                <td
                  class="my-data-td"
                  style="width:1%!important;"
                  v-if="
                    crudComputedECashFlowDateBool === 1 ||
                      crudComputedECashFlowDateBool === 3
                  "
                >
                  <label class="txt-label">
                    <i
                      v-show="errors.has('planned_expiration_date')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Expected Cash Flow Date
                  </label>
                  <input
                    v-validate="'required|date_format:yyyy-MM-dd'"
                    style="height: 19px!important;"
                    type="date"
                    class="custom-input-2"
                    name="planned_expiration_date"
                    placeholder="yyyy-mm-dd"
                    v-model="newEditedItemExpo.planned_expiration_date"
                    :class="{
                      input: true,
                      'is-danger': errors.has('planned_expiration_date'),
                    }"
                  />
                </td>
              </tr>
              <tr>
                <td
                  class="my-data-td"
                  v-if="crudComputedECashFlowDateBool !== 3"
                >
                  <label class="txt-label">
                    <i
                      v-show="errors.has('issue_date')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Invoice Issue Date
                  </label>
                  <input
                    v-validate="'required|date_format:yyyy-MM-dd'"
                    class="custom-input-2"
                    name="issue_date"
                    placeholder="yyyy-mm-dd"
                    v-model="newEditedItemExpo.issue_date"
                    :class="{
                      input: true,
                      'is-danger': errors.has('issue_date'),
                    }"
                    type="date"
                  />
                </td>
                <td
                  class="my-data-td"
                  v-if="crudComputedECashFlowDateBool !== 3"
                >
                  <label class="txt-label">
                    <i
                      v-show="errors.has('rate_at_issue_date')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Rate at Issue Date
                  </label>
                  <input
                    v-validate="'required|min_value:0|decimal:18'"
                    class="custom-input-2"
                    name="rate_at_issue_date"
                    placeholder="Rate"
                    v-model="newEditedItemExpo.rate_at_issue_date"
                    :class="{
                      input: true,
                      'is-danger': errors.has('rate_at_issue_date'),
                    }"
                    type="number"
                    step="0.000000000000000001"
                  />
                </td>
                <td
                  class="my-data-td"
                  v-if="crudComputedECashFlowDateBool !== 3"
                >
                  <label class="txt-label">
                    <i
                      v-show="errors.has('expiration_date')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Invoice Due Date
                  </label>
                  <input
                    v-validate="'required|date_format:yyyy-MM-dd'"
                    class="custom-input-2"
                    name="expiration_date"
                    placeholder="yyyy-mm-dd"
                    v-model="newEditedItemExpo.expiration_date"
                    :class="{
                      input: true,
                      'is-danger': errors.has('expiration_date'),
                    }"
                    type="date"
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <br />
          <!-- ============= optional fields =============  -->
          Optional fields:<br />
          <table
            class="my-data-table table table-sm table-responsive table-borderless table-data-controls"
            style="width: 100%;"
          >
            <tbody>
              <tr>
                <td
                  class="my-data-td"
                  v-if="crudComputedECashFlowDateBool === 0"
                >
                  <label class="txt-label">
                    <i
                      v-show="errors.has('planned_expiration_date')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Expected Cash Flow Date
                  </label>
                  <input
                    v-validate="'date_format:yyyy-MM-dd'"
                    type="date"
                    class="custom-input-2"
                    name="planned_expiration_date"
                    placeholder="yyyy-mm-dd"
                    v-model="newEditedItemExpo.planned_expiration_date"
                    :class="{
                      input: true,
                      'is-danger': errors.has('planned_expiration_date'),
                    }"
                  />
                </td>
              </tr>
              <tr>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('hedged_date')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Hedged Date
                  </label>
                  <input
                    v-validate="'date_format:yyyy-MM-dd'"
                    type="date"
                    class="custom-input-2"
                    name="hedged_date"
                    placeholder="yyyy-mm-dd"
                    v-model="newEditedItemExpo.hedged_date"
                    :class="{
                      input: true,
                      'is-danger': errors.has('hedged_date'),
                    }"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('sale_date')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Exposure End Date
                  </label>
                  <input
                    v-validate="'date_format:yyyy-MM-dd'"
                    type="date"
                    class="custom-input-2"
                    name="sale_date"
                    placeholder="yyyy-mm-dd"
                    v-model="newEditedItemExpo.sale_date"
                    :class="{
                      input: true,
                      'is-danger': errors.has('sale_date'),
                    }"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('shipping_date')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Shipping Date
                  </label>
                  <input
                    v-validate="'date_format:yyyy-MM-dd'"
                    type="date"
                    class="custom-input-2"
                    name="shipping_date"
                    placeholder="yyyy-mm-dd"
                    v-model="newEditedItemExpo.shipping_date"
                    :class="{
                      input: true,
                      'is-danger': errors.has('shipping_date'),
                    }"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('hedge_asset')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Hedged Asset
                  </label>
                  <input
                    v-validate="'max:150'"
                    class="custom-input-2"
                    name="hedge_asset"
                    placeholder="Asset"
                    v-model="newEditedItemExpo.hedge_asset"
                    :class="{
                      input: true,
                      'is-danger': errors.has('hedge_asset'),
                    }"
                    type="text"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('end_product')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    End Product Hedged
                  </label>
                  <input
                    v-validate="'max:150'"
                    class="custom-input-2"
                    name="end_product"
                    placeholder="Product"
                    v-model="newEditedItemExpo.end_product"
                    :class="{
                      input: true,
                      'is-danger': errors.has('end_product'),
                    }"
                    type="text"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('custom_name')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Custom Exposure Name
                  </label>
                  <input
                    v-validate="'max:150'"
                    class="custom-input-2"
                    name="custom_name"
                    placeholder="Custom Name"
                    v-model="newEditedItemExpo.custom_name"
                    :class="{
                      input: true,
                      'is-danger': errors.has('custom_name'),
                    }"
                    type="text"
                  />
                </td>
              </tr>
              <tr>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('custom_id')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Custom Exposure Id
                  </label>
                  <input
                    v-validate="'max:150'"
                    class="custom-input-2"
                    name="custom_id"
                    placeholder="Custom Id"
                    v-model="newEditedItemExpo.custom_id"
                    :class="{
                      input: true,
                      'is-danger': errors.has('custom_id'),
                    }"
                    type="text"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('provider')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Provider Name
                  </label>
                  <input
                    v-validate="'max:150'"
                    class="custom-input-2"
                    name="provider"
                    placeholder="Provider Name"
                    v-model="newEditedItemExpo.provider"
                    :class="{
                      input: true,
                      'is-danger': errors.has('provider'),
                    }"
                    type="text"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('client')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Client Name
                  </label>
                  <input
                    v-validate="'max:150'"
                    class="custom-input-2"
                    name="client"
                    placeholder="Client Name"
                    v-model="newEditedItemExpo.client"
                    :class="{
                      input: true,
                      'is-danger': errors.has('client'),
                    }"
                    type="text"
                  />
                </td>
                <td class="my-data-td">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('plant')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Plant Supplied/Production
                  </label>
                  <input
                    v-validate="'max:150'"
                    class="custom-input-2"
                    name="plant"
                    placeholder="Plant Name"
                    v-model="newEditedItemExpo.plant"
                    :class="{
                      input: true,
                      'is-danger': errors.has('plant'),
                    }"
                    type="text"
                  />
                </td>
                <td class="my-data-td" colspan="2">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('comments')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Comments
                  </label>
                  <input
                    v-validate="'max:150'"
                    class="custom-input-2"
                    name="Comments"
                    placeholder="Comments"
                    v-model="newEditedItemExpo.comments"
                    :class="{
                      input: true,
                      'is-danger': errors.has('comments'),
                    }"
                    type="text"
                  />
                </td>
              </tr>
              <tr>
                <td class="my-data-td" v-show="plannedDateAux < today">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('rate_at_realized_expiration_date')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Settlement Rate
                  </label>
                  <input
                    v-validate="'min_value:0|decimal:18'"
                    class="custom-input-2"
                    name="rate_at_realized_expiration_date"
                    placeholder="Rate"
                    v-model="newEditedItemExpo.rate_at_realized_expiration_date"
                    :class="{
                      input: true,
                      'is-danger': errors.has(
                        'rate_at_realized_expiration_date',
                      ),
                    }"
                    type="number"
                    step="0.000000000000000001"
                  />
                </td>
                <td class="my-data-td" v-show="plannedDateAux < today">
                  <label class="txt-label">
                    <i
                      v-show="errors.has('settlement_pnl')"
                      class="fa fa-warning warn-my-data"
                    ></i>
                    Settlement PnL
                  </label>
                  <input
                    v-validate="'decimal:18'"
                    class="custom-input-2"
                    name="settlement_pnl"
                    placeholder="Profit or Loss"
                    v-model="newEditedItemExpo.settlement_pnl"
                    :class="{
                      input: true,
                      'is-danger': errors.has('settlement_pnl'),
                    }"
                    type="number"
                    step="0.000000000000000001"
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <!-- ============= Buttons =============  -->
          <div class="row f-row">
            <div
              class="col col-6 text-right align-right"
              style="padding-right: 5px;"
            >
              <button class="btn btn-sm btn-home" v-on:click="onUserCancel">
                Cancel
              </button>
            </div>
            <div
              class="col col-6 text-left align-left"
              style="padding-left: 5px;"
            >
              <button class="btn btn-sm btn-home">
                Accept
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <!-- ============= Show Errors =============  -->
    <div class="row f-row mt-3">
      <div class="col col-1"></div>
      <div class="col col-10 btn-warn">
        <span v-show="errors.has('portfolio')"
          >{{ errors.first("portfolio") }}.<br
        /></span>
        <span v-show="errors.has('notional')"
          >{{ errors.first("notional") }}.<br
        /></span>
        <span v-show="errors.has('planned_expiration_date')"
          >{{ errors.first("planned_expiration_date") }}.<br
        /></span>
        <span v-show="errors.has('issue_date')"
          >{{ errors.first("issue_date") }}.<br
        /></span>
        <span
          v-show="
            crudComputedECashFlowDateBool !== 3 && +plannedDateAux < +today
          "
          >Expected Cash Flow Date &#8805; Invoice Issue Date.<br
        /></span>
        <span v-show="errors.has('rate_at_issue_date')"
          >{{ errors.first("rate_at_issue_date") }}.<br
        /></span>
        <span v-show="errors.has('expiration_date')"
          >{{ errors.first("expiration_date") }}.<br
        /></span>
        <span v-show="errors.has('hedge_asset')"
          >{{ errors.first("hedge_asset") }}.<br
        /></span>
        <span v-show="errors.has('end_product')"
          >{{ errors.first("end_product") }}.<br
        /></span>
        <span v-show="errors.has('custom_name')"
          >{{ errors.first("custom_name") }}.<br
        /></span>
        <span v-show="errors.has('custom_id')"
          >{{ errors.first("custom_id") }}.<br
        /></span>
        <span v-show="errors.has('provider')"
          >{{ errors.first("provider") }}.<br
        /></span>
        <span v-show="errors.has('client')"
          >{{ errors.first("client") }}.<br
        /></span>
        <span v-show="errors.has('plant')"
          >{{ errors.first("plant") }}.<br
        /></span>
        <span v-show="errors.has('Comments')"
          >{{ errors.first("comments") }}.<br
        /></span>
        <span v-show="errors.has('rate_at_realized_expiration_date')"
          >{{ errors.first("rate_at_realized_expiration_date") }}.<br
        /></span>
        <span v-show="errors.has('settlement_pnl')"
          >{{ errors.first("settlement_pnl") }}.<br
        /></span>
      </div>
    </div>
  </div>
</template>

<script>
import { timeParse } from "d3";
import InputNumber from "@/components/InputNumber";
import { prepDate, todayWithoutTime } from "@/_core/_helpers/_helpers";

export default {
  name: "NewEditExpoCurrencies",
  props: {
    allCurrencies: { required: true },
    colorTheme: { required: true, type: Boolean, default: true },
    createEditTextExpo: { required: true },
    editedItemExpo: { required: true },
    expoOptions: { required: true },
  },
  components: {
    InputNumber,
  },
  data() {
    return {
      logo_white: require("@/assets/images/QuanspireLogoWhite.svg"),
      logo_blue: require("@/assets/images/QuanspireLogoBlue.svg"),
      logo: require("@/assets/images/QuanspireLogoWhite.svg"),
      today: todayWithoutTime(),
      leftRightCurrExpo: "",
      newEditedItemExpo: {
        pk: "pending",
        edited: false,
        fk_idportafolio: "IMPORTS",
        fk_idcurrency: "EURUSD",
        fk_idexposureoption: "ACCOUNTS PAYABLE",
        notional: "1000000",
        fk_idcountry_currency: "EUR",
        planned_expiration_date: "2025-01-15",
        rate_at_realized_expiration_date: "",
        settlement_pnl: "",
        issue_date: "",
        rate_at_issue_date: "",
        expiration_date: "",
        custom_name: "",
        provider: "",
        client: "",
        plant: "",
        comments: "",
        settlement_rate: "",
      },
    };
  },
  created() {
    this.createNewEdited();
  },
  mounted() {
    if (this.colorTheme) {
      this.logo_white = require("@/assets/images/QuanspireLogoWhite.svg");
      this.logo = require("@/assets/images/QuanspireLogoWhite.svg");
    } else if (!this.colorTheme) {
      this.logo_white = require("@/assets/images/QuanspireLogoBlack.svg");
      this.logo = require("@/assets/images/QuanspireLogoBlack.svg");
    }
  },
  watch: {
    colorTheme() {
      if (this.colorTheme) {
        this.logo_white = require("@/assets/images/QuanspireLogoWhite.svg");
        this.logo = require("@/assets/images/QuanspireLogoWhite.svg");
      } else if (!this.colorTheme) {
        this.logo_white = require("@/assets/images/QuanspireLogoBlack.svg");
        this.logo = require("@/assets/images/QuanspireLogoBlack.svg");
      }
    },
    editedItemExpo() {
      this.createNewEdited();
    },
  },
  computed: {
    plannedDateAux() {
      return timeParse("%Y-%m-%d")(
        this.newEditedItemExpo.planned_expiration_date,
      );
    },
    crudComputedECashFlowDateBool() {
      if (this.expoOptions.length > 0) {
        let idx = 0;
        let vis = this;
        for (var i = 0; i < vis.expoOptions.length; i++) {
          if (
            vis.expoOptions[i].name ===
            vis.newEditedItemExpo.fk_idexposureoption
          ) {
            idx = i;
          }
        }
        if (this.expoOptions[idx].name.toUpperCase() === "INITIAL CASH FLOW") {
          return 2;
        } else if (
          this.expoOptions[idx].name.toUpperCase().includes("PROJECTED")
        ) {
          return 3;
        } else if (
          this.expoOptions[idx].exposure_options.toUpperCase() === "BALANCE"
        ) {
          return 0;
        } else {
          return 1;
        }
      } else {
        return true;
      }
    },
  },
  methods: {
    createNewEdited() {
      this.newEditedItemExpo = JSON.parse(JSON.stringify(this.editedItemExpo));
      this.leftRightCurrExpo = [
        this.newEditedItemExpo.fk_idcurrency.slice(0, 3),
        this.newEditedItemExpo.fk_idcurrency.slice(3, 6),
      ];
      // Dates
      this.newEditedItemExpo.issue_date = prepDate(
        this.newEditedItemExpo.issue_date,
      );
      this.newEditedItemExpo.expiration_date = prepDate(
        this.newEditedItemExpo.expiration_date,
      );
      this.newEditedItemExpo.planned_expiration_date = prepDate(
        this.newEditedItemExpo.planned_expiration_date,
      );
      this.newEditedItemExpo.realized_expiration_date = prepDate(
        this.newEditedItemExpo.realized_expiration_date,
      );
      this.newEditedItemExpo.hedged_date = prepDate(
        this.newEditedItemExpo.hedged_date,
      );
      this.newEditedItemExpo.sale_date = prepDate(
        this.newEditedItemExpo.sale_date,
      );
      this.newEditedItemExpo.shipping_date = prepDate(
        this.newEditedItemExpo.shipping_date,
      );
    },
    // ===== events =====
    onUserCancel() {
      this.$emit("eventOnUserCancel");
    },
    onUserNotionalChange(val) {
      this.newEditedItemExpo.notional = Math.max(0, val);
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (
            JSON.parse(JSON.stringify(this.editedItemExpo)) ===
              JSON.parse(JSON.stringify(this.newEditedItemExpo)) &&
            this.createEditTextExpo === "Edit Exposure"
          ) {
            this.$emit("eventOnUserCancel");
          } else {
            this.newEditedItemExpo.edited = true;
            this.$emit("eventOnValidateBeforeSubmit", this.newEditedItemExpo);
          }
        }
      });
    },
    onCrudExpoCurrency(event) {
      let idx = event.target.options.selectedIndex;
      let item = this.allCurrencies[idx].currency_name;
      this.leftRightCurrExpo = [item.slice(0, 3), item.slice(3, 6)];
      this.newEditedItemExpo.fk_idcountry_currency = item.slice(0, 3);
    },
  },
};
</script>
